(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else root.MimosaChickCore=api;
})(typeof window!=='undefined'?window:this,function(){
  function positiveInteger(value,fallback){
    const parsed=parseInt(value,10);
    return Number.isFinite(parsed)&&parsed>0?parsed:fallback;
  }
  function normalizeQuantity(quantity,minimum){
    const min=positiveInteger(minimum,1);
    return Math.max(positiveInteger(quantity,min),min);
  }
  function validateSelection(selected,limit){
    const count=Array.isArray(selected)?selected.length:0;
    const required=positiveInteger(limit,0);
    return{valid:count===required,remaining:Math.max(required-count,0),excess:Math.max(count-required,0)};
  }
  function hasBloodyMary(cart){
    const found=cart&&Array.isArray(cart.items)&&cart.items.find(item=>item&&item.handle==='bloody-mary-chick');
    return found?'bloody-mary-chick':false;
  }
  function buildProperties(flavors,quantity){
    return{'Selected Mimosa Flavors':flavors.join(', '),'Guest Quantity':String(quantity)};
  }
  return{normalizeQuantity,validateSelection,hasBloodyMary,buildProperties};
});
